import { _ as _$3 } from '@swc/helpers/esm/_call_super.js';
import { _ as _$2 } from '@swc/helpers/esm/_class_call_check.js';
import { _ as _$4 } from '@swc/helpers/esm/_create_class.js';
import { _ } from '@swc/helpers/esm/_define_property.js';
import { _ as _$1 } from '@swc/helpers/esm/_inherits.js';
import { _ as _$6 } from '@swc/helpers/esm/_object_spread.js';
import { _ as _$5 } from '@swc/helpers/esm/_object_spread_props.js';
import { createRef, h, Component } from 'preact';
import Template from '../Template/Template.js';
import { noop } from '../../lib/utils/noop.js';

var defaultProps = {
    query: '',
    showSubmit: true,
    showReset: true,
    showLoadingIndicator: true,
    autofocus: false,
    searchAsYouType: true,
    ignoreCompositionEvents: false,
    isSearchStalled: false,
    disabled: false,
    ariaLabel: 'Search',
    onChange: noop,
    onSubmit: noop,
    onReset: noop,
    refine: noop,
    inputProps: {}
};
var SearchBox = /*#__PURE__*/ function(Component) {
    _$1(SearchBox, Component);
    function SearchBox() {
        _$2(this, SearchBox);
        var _this;
        _this = _$3(this, SearchBox, arguments), _(_this, "state", {
            query: _this.props.query,
            focused: false
        }), _(_this, "input", createRef()), _(_this, "onInput", function(event) {
            var // @ts-expect-error the context incompatibility of `this` doesn't matter
            _this_props_inputProps_onInput, _this_props_inputProps;
            (_this_props_inputProps_onInput = (_this_props_inputProps = _this.props.inputProps).onInput) === null || _this_props_inputProps_onInput === void 0 ? void 0 : _this_props_inputProps_onInput.call(_this_props_inputProps, event);
            var _this_props = _this.props, searchAsYouType = _this_props.searchAsYouType, refine = _this_props.refine, onChange = _this_props.onChange;
            var query = event.target.value;
            if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
                if (searchAsYouType) {
                    refine(query);
                }
                _this.setState({
                    query: query
                });
                onChange(event);
            }
        }), _(_this, "onSubmit", function(event) {
            var _this_props = _this.props, searchAsYouType = _this_props.searchAsYouType, refine = _this_props.refine, onSubmit = _this_props.onSubmit;
            event.preventDefault();
            event.stopPropagation();
            if (_this.input.current) {
                _this.input.current.blur();
            }
            if (!searchAsYouType) {
                refine(_this.state.query);
            }
            onSubmit(event);
            return false;
        }), _(_this, "onReset", function(event) {
            var _this_props = _this.props, refine = _this_props.refine, onReset = _this_props.onReset;
            var query = '';
            if (_this.input.current) {
                _this.input.current.focus();
            }
            refine(query);
            _this.setState({
                query: query
            });
            onReset(event);
        }), _(_this, "onBlur", function(event) {
            var // @ts-expect-error the context incompatibility of `this` doesn't matter
            _this_props_inputProps_onBlur, _this_props_inputProps;
            (_this_props_inputProps_onBlur = (_this_props_inputProps = _this.props.inputProps).onBlur) === null || _this_props_inputProps_onBlur === void 0 ? void 0 : _this_props_inputProps_onBlur.call(_this_props_inputProps, event);
            _this.setState({
                focused: false
            });
        }), _(_this, "onFocus", function(event) {
            var // @ts-expect-error the context incompatibility of `this` doesn't matter
            _this_props_inputProps_onFocus, _this_props_inputProps;
            (_this_props_inputProps_onFocus = (_this_props_inputProps = _this.props.inputProps).onFocus) === null || _this_props_inputProps_onFocus === void 0 ? void 0 : _this_props_inputProps_onFocus.call(_this_props_inputProps, event);
            _this.setState({
                focused: true
            });
        });
        return _this;
    }
    _$4(SearchBox, [
        {
            key: "resetInput",
            value: /**
   * This public method is used in the RefinementList SFFV search box
   * to reset the input state when an item is selected.
   *
   * @see RefinementList#componentWillReceiveProps
   * @return {undefined}
   */ function resetInput() {
                this.setState({
                    query: ''
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                /**
     * when the user is typing, we don't want to replace the query typed
     * by the user (state.query) with the query exposed by the connector (props.query)
     * see: https://github.com/algolia/instantsearch/issues/4141
     */ if (!this.state.focused && nextProps.query !== this.state.query) {
                    this.setState({
                        query: nextProps.query
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, cssClasses = _this_props.cssClasses, placeholder = _this_props.placeholder, autofocus = _this_props.autofocus, showSubmit = _this_props.showSubmit, showReset = _this_props.showReset, showLoadingIndicator = _this_props.showLoadingIndicator, templates = _this_props.templates, isSearchStalled = _this_props.isSearchStalled, ariaLabel = _this_props.ariaLabel, inputProps = _this_props.inputProps;
                return /*#__PURE__*/ h("div", {
                    className: cssClasses.root
                }, /*#__PURE__*/ h("form", {
                    action: "",
                    role: "search",
                    className: cssClasses.form,
                    noValidate: true,
                    onSubmit: this.onSubmit,
                    onReset: this.onReset
                }, /*#__PURE__*/ h("input", _$5(_$6({}, inputProps), {
                    ref: this.input,
                    value: this.state.query,
                    disabled: this.props.disabled,
                    className: cssClasses.input,
                    type: "search",
                    placeholder: placeholder,
                    autoFocus: autofocus,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    // @ts-expect-error `spellCheck` attribute is missing in preact JSX types
                    spellCheck: "false",
                    maxLength: 512,
                    onInput: this.onInput,
                    // see: https://github.com/preactjs/preact/issues/1978
                    // eslint-disable-next-line react/no-unknown-property
                    oncompositionend: this.onInput,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    "aria-label": ariaLabel
                })), /*#__PURE__*/ h(Template, {
                    templateKey: "submit",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.submit,
                        type: 'submit',
                        title: 'Submit the search query',
                        hidden: !showSubmit
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), /*#__PURE__*/ h(Template, {
                    templateKey: "reset",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.reset,
                        type: 'reset',
                        title: 'Clear the search query',
                        hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), showLoadingIndicator && /*#__PURE__*/ h(Template, {
                    templateKey: "loadingIndicator",
                    rootTagName: "span",
                    rootProps: {
                        className: cssClasses.loadingIndicator,
                        hidden: !isSearchStalled
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                })));
            }
        }
    ]);
    return SearchBox;
}(Component);
_(SearchBox, "defaultProps", defaultProps);

export { SearchBox as default };
